import api from "@/lib/api";

export interface PostApplyNewContractRequest {
  activationCode: string;
  planCode: string;
}

export interface PostApplyNewContractResponse {
  contractNumber: string;
  status: string;
  message_type: string;
  errorCode: string;
}

export interface PostApplyExistingContractRequest {
  activationCode: string;
  contractNumber: string;
}

export interface PostApplyExistingContractResponse {
  contractNumber: string;
  status: string;
  message_type: string;
  errorCode: string;
}

export default {
  postApplyNewContract(data: PostApplyNewContractRequest) {
    return api<PostApplyNewContractRequest, PostApplyNewContractResponse>({
      endpoint: "activation-codes/web-api/apply-new-contract",
      method: "POST",
      body: data
    });
  },
  postUpdatepassApplyNewContract(data: PostApplyNewContractRequest) {
    return api<PostApplyNewContractRequest, PostApplyNewContractResponse>({
      endpoint: "activation-codes/web-api/updatepass-apply-new-contract",
      method: "POST",
      body: data
    });
  },
  postPerpetualNewLicense(data: PostApplyNewContractRequest) {
    return api<PostApplyNewContractRequest, PostApplyNewContractResponse>({
      endpoint: "activation-codes/web-api/perpetual-new-license",
      method: "POST",
      body: data
    });
  },
  postApplyExistingContract(data: PostApplyExistingContractRequest) {
    return api<
      PostApplyExistingContractRequest,
      PostApplyExistingContractResponse
    >({
      endpoint: "activation-codes/web-api/apply-existing-contract",
      method: "POST",
      body: data
    });
  },
  postUpdatepassApplyExistingContract(data: PostApplyExistingContractRequest) {
    return api<
      PostApplyExistingContractRequest,
      PostApplyExistingContractResponse
    >({
      endpoint: "activation-codes/web-api/updatepass-apply-existing-contract",
      method: "POST",
      body: data
    });
  },

  postApplyNewContractForPaint(data: PostApplyNewContractRequest) {
    return api<PostApplyNewContractRequest, PostApplyNewContractResponse>({
      endpoint: "ice/activation-codes/web-api/apply-new-contract",
      method: "POST",
      body: data
    });
  },
  postApplyExistingContractForPaint(data: PostApplyExistingContractRequest) {
    return api<
      PostApplyExistingContractRequest,
      PostApplyExistingContractResponse
    >({
      endpoint: "ice/activation-codes/web-api/apply-existing-contract",
      method: "POST",
      body: data
    });
  }
};
